import DownloadIcon from '@mui/icons-material/Download';
import { Button, CircularProgress, createTheme, Grid, Link, Modal, Stack, TableHead, ThemeProvider } from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { visuallyHidden } from '@mui/utils';
import axios from '../../common/api/axiosConfig';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import ErrorSnackbarNotification from '../../common/ErrorHandling/ErrorSnackbarAlert';
import { styles } from '../../style/style';
import { setOrderDetailData, setOrderDetailSearch, setOrderSearchType } from '../orderdetail/orderDetailSlice';
import { useIntl } from 'react-intl';
import log from '../../common/components/Logger'



function createData(orderNum, failedEdits, currentEvent, eventDate, division, allocationGroup, model, modelYear, numOfVehicles, shipToBAC, custPoNbr, orderReceiptDate, actualTPW, balanceToGo, parentOrderNum, primaryFAN, endUserFAN, vin, chargeToBac, orderTypeCd) {
  return {
    orderNum,
    failedEdits,
    currentEvent,
    eventDate,
    division,
    allocationGroup,
    model,
    modelYear,
    numOfVehicles,
    shipToBAC,
    custPoNbr,
    orderReceiptDate,
    actualTPW,
    balanceToGo,
    parentOrderNum,
    primaryFAN,
    endUserFAN,
    vin,
    chargeToBac,
    orderTypeCd
  };
}

function createDataForExcel(failedEdit,primaryFan,endUserFan,orderNumber,OrderReceiptDate,poNumber,numOfVehicles,currentEventCode,eventCodeDate,requestedTPW,allocationGroup,actualTPW,model,modelYear,chargeToBAC,shipToBAC,chargeToBFC,shipToBFC,shippedDate,producedDate,vin,orderOptions) {
  return  {
    failedEdit,
    primaryFan,
    endUserFan,
    orderNumber,
    OrderReceiptDate,
    poNumber,
    numOfVehicles,
    currentEventCode,
    eventCodeDate,
    requestedTPW,
    allocationGroup,
    actualTPW,
    model,
    modelYear,
    chargeToBAC,
    shipToBAC,
    chargeToBFC,
    shipToBFC,
    shippedDate,
    producedDate,
    vin
  }
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const headCells = [
    {
      id: 'orderNum',
      numeric: false,
      disablePadding: true,
      minWidth: 170,
      label: <FormattedMessage id="orderRequestList.orderNumber" defaultMessage='Order Number' />
    },
    {
      id: 'failedEdits',
      numeric: false,
      disablePadding: false,
      label: <FormattedMessage id="orderRequestList.failedEdits" defaultMessage='Failed Edits' />
    },
    {
      id: 'currentEvent',
      numeric: false,
      disablePadding: false,
      label: <FormattedMessage id="orderRequestList.currentEvent" defaultMessage='Current Event' />
    },
    {
      id: 'eventDate',
      numeric: false,
      disablePadding: false,
      label: <FormattedMessage id="orderRequestList.eventDate" defaultMessage='Event Date' />
    },
    {
      id: 'division',
      numeric: false,
      disablePadding: false,
      label: <FormattedMessage id="orderRequestList.division" defaultMessage='Division' />
    },
    {
      id: 'allocationGroup',
      numeric: false,
      disablePadding: false,
      label: <FormattedMessage id="orderRequestList.allocationGroup" defaultMessage='Allocation Group' />
    },
    {
      id: 'model',
      numeric: false,
      disablePadding: false,
      label: <FormattedMessage id="orderRequestList.model" defaultMessage='Model' />
    },
    {
      id: 'modelYear',
      numeric: true,
      disablePadding: false,
      label: <FormattedMessage id="orderRequestList.modelYear" defaultMessage='Model Year' />
    },
    {
      id: 'numOfVehicles',
      numeric: true,
      disablePadding: false,
      label: <FormattedMessage id="orderRequestList.numberOfVehicles" defaultMessage='Number Of Vehicls' />
    },
    {
      id: 'shipToBAC',
      numeric: false,
      disablePadding: false,
      label: <FormattedMessage id="orderRequestList.shipToBac" defaultMessage='Ship To BAC' />
    },
    {
      id: 'custPoNbr',
      numeric: true,
      disablePadding: false,
      label: <FormattedMessage id="orderRequestList.poNumber" defaultMessage='P.O. Number' />
    },
    {
      id: 'orderReceiptDate',
      numeric: false,
      disablePadding: false,
      label: <FormattedMessage id="orderRequestList.orderReceiptDate" defaultMessage='Order Receipt Date' />
    },
    {
      id: 'actualTPW',
      numeric: false,
      disablePadding: false,
      label: <FormattedMessage id="orderRequestList.actualTpw" defaultMessage='Actual TPW' />
    },
    {
      id: 'balanceToGo',
      numeric: false,
      disablePadding: false,
      label: <FormattedMessage id="orderRequestList.balanceToGo" defaultMessage='Balance To Go' />
    },
    {
      id: 'parentOrderNum',
      numeric: false,
      disablePadding: false,
      label: <FormattedMessage id="orderRequestList.parentOrderNumber" defaultMessage='Parent Order Number' />
    },
    {
      id: 'primaryFAN',
      numeric: true,
      disablePadding: false,
      label: <FormattedMessage id="orderRequestList.primaryFan" defaultMessage='Primary FAN' />
    },
    {
      id: 'endUserFAN',
      numeric: true,
      disablePadding: false,
      label: <FormattedMessage id="orderRequestList.endUserFan" defaultMessage='End User FAN' />
    },
    {
      id: 'orderTypeCd',
      numeric: true,
      disablePadding: false,
      label: <FormattedMessage id="orderRequestList.orderTypeCode" defaultMessage='Order Type Code' />
    },
  ];

  return (
    <TableHead>
      <TableRow
        sx={styles.orderRequestListRow}
      >
        <TableCell
          sx={styles.orderRequestListStickyHeader}
          variant='head'
          align='left'
          key={'orderNum'}
          sortDirection={orderBy === 'orderNum' ? order : false}
        >
          <TableSortLabel
            id="orderNumHeader"
            active={orderBy === 'orderNum'}
            direction={orderBy === 'orderNum' ? order : 'asc'}
            onClick={createSortHandler('orderNum')}
          >

            <FormattedMessage id="orderRequestList.orderNumber" defaultMessage='Order Number' />
            {orderBy === 'orderNum' ? (
              <Box component="span" sx={visuallyHidden}>
                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
              </Box>
            ) : null}
          </TableSortLabel>
        </TableCell>

        {headCells.slice(1).map((headCell) => (

          <TableCell
            sx={styles.orderRequestListHeader}
            variant='head'
            key={headCell.id}
            align='left'
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          > 
            <TableSortLabel
              id={headCell.id + "Header"}
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const EnhancedTableToolbar = (props) => {

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 }
      }}
    >
      <IconButton id="exportButton" aria-label='Download to Excel' onClick={props.exportToExcel}><DownloadIcon /></IconButton>
    </Toolbar>
  );
};


// EnhancedTableToolbar.propTypes = {
//   handleDownload: PropTypes.func.isRequired
// };

export default function OrderRequestList() {
  const login = useSelector((state) => state.login.data.payload.login);

  if (!login) {
    window.location.href = '/home';
  }

  const intl = useIntl();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [tableData, setTableData] = React.useState([]);
  const idToken = localStorage.getItem("idToken");
  const [loading, setLoading] = React.useState();
  const [open, setOpen] = React.useState(false);
  const [orderListData, setOrderListData] = React.useState([]);
  const [companyName, setCompanyName] = React.useState("");
  const [shipToBac, setShipToBac] = React.useState("");
  const [city, setCity] = React.useState("");
  const [state, setState] = React.useState("");
  const [statusMessage, setStatusMessage] = React.useState("");

  // all use selectors from redux
  const dispatch = useDispatch();
  //const ordersNotFoundMessage = useSelector((state) => state.orderList.data.payload.ordersNotFoundMessage);
  //const invalidOrdersMessage = useSelector((state) => state.orderList.data.payload.invalidOrdersMessage);
  //const invalidSearchItem = useSelector((state) => state.orderList.data.payload.invalidSearchItem);
  const ApiList = useSelector((state) => state.apiList.apiList);
  const orderSearchByType = useSelector((state) => state.orderList.orderRequestSearchType.payload);
  const orderRequestSearchField = useSelector((state) => state.orderList.orderRequestSearchField.payload);
  const orderListRedux = useSelector((state) => state.orderList.data.payload);
  const userDetails = useSelector((state) => state.user.data.payload);

  // error states
  const [error, setError] = React.useState([]);
  const [errorMessage, setErrorMessage] = React.useState([]);
  const [errorType, setErrorType] = React.useState();
  const [landingErrorMessage, setLandingErrorMessage] = React.useState(null);
  const [openErrorMessage, setOpenErrorMessage] = React.useState(false);
  const [isLoading, setLoadingSetter] = React.useState(true);

  function dataLoad() {
    if (orderSearchByType === 'leftClick') {
      setOrderListData(orderListRedux.orderRequestList);
      //setRows();
    } else {

      /* const url = ApiList.summarybyallocationgroup; */
      let url;

      const config = {
        headers: {
          method: 'POST',
          'Content-Type': 'application/json'
        }
      };

      //if (orderSearchByType === 'rightClick-Allocation') {
        //url = ApiList.summarybyallocationgroup;
      //} else if (orderSearchByType === 'rightClick-Model') {
        //url = ApiList.summarybymodel;
      //} else if (orderSearchByType === 'OrderList') {
        //url = ApiList.advancedOrderList;
      //} else if (orderSearchByType === 'OrderListLanding') {
        //url = ApiList.ordernumsearch;
      //}

      if (orderSearchByType === 'rightClick-Allocation') {
        url = ApiList.summarybyallocationgroup;
        axios.post(url, orderRequestSearchField, config)
        .then(response => {
          if (response.data.statusMessage === 'SUCCESS') {
            log.info(`fos_ui_log: OrderRequestList():allocationGroupSummary(): Successful data fetch by allocation`)
            setOrderListData(response.data.orderRequestList);
            setRows();
            setLoadingSetter(false);
          } else {
            setError(true)
            setErrorType('error')
            setStatusMessage(intl.formatMessage({ id: response.data.statusMessage, defaultMessage: "Error Found" }))
            setLoadingSetter(false);
            log.info(`fos_ui_log: OrderRequestList():allocationGroupSummary(): ${response.data.statusMessage}`)
          }  
        })
        .catch((err) => {
          setError(true)
          setErrorType('error')
          setStatusMessage(intl.formatMessage({ id: err.message.toString().toUpperCase().replace(/ /g, "_"), defaultMessage: err.message }))
          setLoadingSetter(false);
          log.error(`fos_ui_log: OrderRequestList():allocationGroupSummary(): ${err.message}`)
        });
        
      } else if (orderSearchByType === 'rightClick-Model') {
        url = ApiList.summarybymodel;
        axios.post(url, orderRequestSearchField, config)
        .then(response => {
          if (response.data.statusMessage === 'SUCCESS') {
            log.info(`fos_ui_log: OrderRequestList():modelSummary(): Successful data fetch by model`)
            setOrderListData(response.data.orderRequestList);
            setRows();
            setLoadingSetter(false);
          } else {
            setError(true)
            setErrorType('error')
            setStatusMessage(intl.formatMessage({ id: response.data.statusMessage, defaultMessage: "Error Found" }))
            setLoadingSetter(false);
            log.info(`fos_ui_log: OrderRequestList():modelSummary(): ${response.data.statusMessage}`)
          }  
        })
        .catch((err) => {
          setError(true)
          setErrorType('error')
          setStatusMessage(intl.formatMessage({ id: err.message.toString().toUpperCase().replace(/ /g, "_"), defaultMessage: err.message }))
          setLoadingSetter(false);
          log.error(`fos_ui_log: OrderRequestList():modelSummary(): ${err.message}`)
        })
      } else if (orderSearchByType === 'OrderList') {
        url = ApiList.advancedOrderList;
        axios.post(url, orderRequestSearchField, config)
        .then((response) => {
          if (response.data.advancedSearchValid === true) {
            if (response.data.statusMessage === 'SUCCESS') {
              log.info(`fos_ui_log: AdvancedSearch():orderList Search: ${response.data.statusMessage}`)
              setOrderListData(response.data.orderRequestList);
              setRows();
              setLoadingSetter(false);
            } else {
              setError(true);
              setLoading(false);
              setErrorType('error');
              setLoadingSetter(false);
              if (response.data.statusMessage !== null) {
                  setErrorMessage(intl.formatMessage({ id: response.data.statusMessage, defaultMessage: "Error Found" }))
                  log.info(`fos_ui_log: AdvancedSearch():orderList Search: ${response.data.statusMessage}`)
              }
            }
          } else {
            setError(true);
            setLoading(false);
            let errorMessage = [];
            if (response.data.invalidPrimaryFanMessage !== null) {
                errorMessage.push(intl.formatMessage({ id: response.data.invalidPrimaryFanMessage, defaultMessage: "Error Found" }));
                log.info(`fos_ui_log: AdvancedSearch():invalidPrimaryFanMessage: ${response.data.invalidPrimaryFanMessage}`)
            }
            if (response.data.invalidEndUserFanMessage !== null) {
                errorMessage.push(intl.formatMessage({ id: response.data.invalidEndUserFanMessage, defaultMessage: "Error Found" }));
                log.info(`fos_ui_log: AdvancedSearch():invalidEndUserFanMessage: ${response.data.invalidEndUserFanMessage}`)
            }
            if (response.data.invalidChargeToBacMessage !== null) {
                errorMessage.push(intl.formatMessage({ id: response.data.invalidChargeToBacMessage, defaultMessage: "Error Found" }));
                log.info(`fos_ui_log: AdvancedSearch():invalidChargeToBacMessage: ${response.data.invalidChargeToBacMessage}`)
            }
            if (response.data.invalidChargeToBfcMessage !== null) {
                errorMessage.push(intl.formatMessage({ id: response.data.invalidChargeToBfcMessage, defaultMessage: "Error Found" }));
                log.info(`fos_ui_log: AdvancedSearch():invalidChargeToBfcMessage: ${response.data.invalidChargeToBfcMessage}`)
            }
            if (response.data.invalidShipToBacMessage !== null) {
                errorMessage.push(intl.formatMessage({ id: response.data.invalidShipToBacMessage, defaultMessage: "Error Found" }));
                log.info(`fos_ui_log: AdvancedSearch():invalidShipToBacMessage: ${response.data.invalidShipToBacMessage}`)
            }
            if (response.data.statusMessage !== '' && response.data.statusMessage !== null) {
                errorMessage.push(intl.formatMessage({ id: response.data.statusMessage, defaultMessage: "Error Found" }));
                log.info(`fos_ui_log: AdvancedSearch(): ${response.data.statusMessage}`)
            }
            setErrorType('error');
            setErrorMessage(errorMessage);
            setLoadingSetter(false);
          }
        })
        .catch((error) => {
          setError(true);
          setLoading(false);
          setErrorType('error');
          setErrorMessage(intl.formatMessage({ id: error.message.toString().toUpperCase().replace(/ /g, "_"), defaultMessage: error.message }))
          setLoadingSetter(false);
          log.error(`fos_ui_log: AdvancedSearch():orderList Search ${error.message}`)
        })
      } else if (orderSearchByType === 'OrderListLanding') {
        url = ApiList.ordernumsearch;
        axios.post(url, orderRequestSearchField, config)
        .then((response) => {
          if (response.data.statusMessage === 'SUCCESS' || response.data.statusMessage === null) {
            if (response.data.orderRequestList) {
              log.info(`fos_ui_log: LandingSearch():orderRequestList: Successful Fetch! ${response.data}`)
              console.log(`fos_ui_log: LandingSearch():orderRequestList: Successful Fetch! ${response.data}`)
              setOrderListData(response.data.orderRequestList);
              setRows();
              setLoadingSetter(false);
            } else {
              if (response.data.ordersNotFoundMessage) {//invalid order number
                setErrorMessage(intl.formatMessage({ id: 'ORDER_NUMBERS_NOT_FOUND', defaultMessage: "Error Found" })) 
                //setErrorMessage(response.data.ordersNotFoundMessage);
                setErrorType('error');
                setLoadingSetter(false);
                log.info(`fos_ui_log: LandingSearch():orderRequestList: ${response.data.ordersNotFoundMessage}`)
                console.log(`fos_ui_log: LandingSearch():orderRequestList: ${response.data.ordersNotFoundMessage}`)
                //  setErrorMessage(intl.formatMessage({ id: response.data.ordersNotFoundMessage, defaultMessage: "Error Found" })) //
              }

              if (response.data.invalidOrdersMessage) {//empty order number
                setErrorMessage(intl.formatMessage({ id: 'SEARCH_LIMIT', defaultMessage: "Error Found" })) 
                //setErrorMessage(response.data.invalidOrdersMessage);
                setErrorType('error');
                setLoadingSetter(false);
                log.info(`fos_ui_log: LandingSearch():orderRequestList: ${response.data.invalidOrdersMessage}`)
                console.log(`fos_ui_log: LandingSearch():orderRequestList: ${response.data.invalidOrdersMessage}`)
                // setErrorMessage(intl.formatMessage({ id: response.data.invalidOrdersMessage, defaultMessage: "Error Found" })); //
              }
            }  
          } else {
            setErrorMessage("ERROR");
            setErrorType('error');
            setLoadingSetter(false);
          }
        })
        .catch((error) => {
          log.error(`fos_ui_log: LandingSearch(): ${error.message}`)
          console.log(`fos_ui_log: LandingSearch(): ${error.message}`)
          setErrorMessage("THERE_WAS_TROUBLE_ACCESSING_THE_DATA");
          setErrorType('error');
          setLoadingSetter(false);
        })
      }



      /*
      axios.post(url, orderRequestSearchField, config)
        .then(response => {
          if (response.data.statusMessage === 'SUCCESS' || response.data.statusMessage === null) {
            log.info(`fos_ui_log: OrderRequestList():dataLoad ${response.data.statusMessage}`)
            setOrderListData(response.data.orderRequestList);
            setRows();
          } else {
            setError(true);
            setLoading(false);
            setErrorType('error');
            if (response.data.statusMessage !== null) {
                setErrorMessage(intl.formatMessage({ id: response.data.statusMessage, defaultMessage: "Error Found" }))
                log.info(`fos_ui_log: AdvancedSearch():handleSearch: ${response.data.statusMessage}`)
            }
          }  
        }).catch(err => log.error(`fos_ui_log: OrderRequestList():dataLoad: ${err.message}`))*/
    }
  }

  useEffect(() => {
    dataLoad();
    console.log(orderListData);
  }, [])

  
  
  useEffect(() => {
    if (orderListData.length > 0) {
      setRows();
    }
  }, [orderListData])

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseError = (reason) => {
    if (reason === 'clickaway') {
        return;
    }
    setError(false);
  };

  function setBacNum(shipToBac) {
    setShipToBac(shipToBac)

    let configDealerInfo;
    const dataDealerInfo = {
      user: {
        userId: userDetails.userId,
        partnerType: userDetails.partnerType,
        preferredLanguage: userDetails.preferredLanguage,
        bac: shipToBac,
        primaryFan: userDetails.primaryFan
      }
    }
    configDealerInfo = {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      }
    };

    axios.post(ApiList.getDealerInfo, dataDealerInfo, configDealerInfo)
      .then((response) => {
        if (response.data.statusMessage === null || response.data.statusMessage === "Success") {
          const dealer = response.data.userProfile;
          handleOpen();
          setCompanyName(dealer.dealerList[0].companyName);
          setCity(dealer.dealerList[0].city);
          setState(dealer.dealerList[0].province);
          log.info(`fos_ui_log: OrderRequestList():dealerInfo Company:${dealer.dealerList[0].companyName} City:${dealer.dealerList[0].city} State:${dealer.dealerList[0].province}`)
        } else {
          setOpenErrorMessage(true)
          setErrorType('error')
          setErrorMessage(intl.formatMessage({ id: response.data.statusMessage, defaultMessage: "Error Found" }))
          log.info(`fos_ui_log: OrderRequestList():dealerInfo ${response.data.statusMessage}`)
        }
      }).catch(err => {
        console.log(err);
        if (err.response.status == 500) {
          setErrorMessage(intl.formatMessage({ id: err.message.toString().toUpperCase().replace(/ /g, "_"), defaultMessage: err.message }))
          log.error(`fos_ui_log: OrderRequestList():dealerInfo ${err.message}`)
        } else {
          log.error(`fos_ui_log: OrderRequestList():dealerInfo ${err.message}`)
        }
      })

  }

  function setRows() {
    let data = [];
    orderListData.map((dataRow) => {
      let rowData = createData(dataRow.orderNum, dataRow.failedEditBasic, dataRow.currentEvntCd, dataRow.eventDate, dataRow.division, dataRow.allocationGroup, dataRow.model, dataRow.modelYear, dataRow.numberOfVehicles, <Typography onClick={() => setBacNum(dataRow.shipToBac)} sx={{ fontSize: '16px', cursor: 'pointer', color: '#0072CE' }}>{dataRow.shipToBac}</Typography>, dataRow.custPoNbr, dataRow.orderReceiptDate, dataRow.actualTPW, dataRow.balance, dataRow.parentOrderNum, dataRow.fanNumber, dataRow.endFanNumber, dataRow.vin, dataRow.chargeToBac, dataRow.orderTypeCode);
      data.push(rowData);
    });
    setTableData(data);
    //setLoadingSetter(false);
  }



  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = tableData.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  function convertDateFormat(dateStringYYYYMMDD){
    if (dateStringYYYYMMDD != null){
      const d_arr = dateStringYYYYMMDD.substring(0, 10).split("-");
      if (d_arr.length === 3) {
        return d_arr[1] + '/' + d_arr[2] + '/' + d_arr[0];
      }
      return dateStringYYYYMMDD;
    }
    return '';
  }


  function convertToExcelData() {
    return orderListData.map((dataRow) => {
      //Change Date Formats to read MM/DD/YYYY and casts it as Date
      var newEventDate = convertDateFormat(dataRow.eventDate);
      var newOrdReceiptDate = convertDateFormat(dataRow.orderReceiptDate);
      var newActTpwDate = convertDateFormat(dataRow.actualTPW);
      var newRqtTpwDate = convertDateFormat(dataRow.requestedTPW);
      var newShippedDate = convertDateFormat(dataRow.shippedDate);
      var newProdDate = convertDateFormat(dataRow.producedDate);

      let rowData = createDataForExcel(dataRow.failedEditBasic, dataRow.fanNumber, dataRow.endFanNumber, dataRow.orderNum, newOrdReceiptDate, dataRow.custPoNbr, dataRow.numberOfVehicles, dataRow.currentEvntCd, newEventDate, newRqtTpwDate, dataRow.allocationGroup, newActTpwDate, dataRow.model, dataRow.modelYear, dataRow.chargeToBac, dataRow.shipToBac, dataRow.chargeToBfc, dataRow.shipToBfc, newShippedDate, newProdDate, dataRow.vin);
      //append orderOptions into the rowData
      rowData["orderOptions"] = dataRow.orderOptions;
      return rowData;
    });
  }

  // called when the download button at the top of the table is pressed
  const exportToExcel = () => {
    log.info(`fos_ui_log: OrderRequestList():exportToExcel Successful Excel Download`)

    const excelData = convertToExcelData();

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(excelData, { origin: 'A2', skipHeader: true });
    const heading = [[ 'Failed Edit', 'Primary FAN', 'End User FAN', 'Order Number', 'Order Receipt Date', 'P.O. Number', 'Number of Vehicles', 'Current Event Code',
    'Event Code Date', 'Requested TPW', 'Allocation Group', 'Actual TPW', 'Model', 'Model Year', 'Charge-To BAC', 'Ship-To BAC', 'Charge-To BFC', 'Ship-To BFC',
    'Shipped Date', 'Produced Date', 'VIN', 'Order Options']];

    XLSX.utils.sheet_add_aoa(worksheet, heading, { origin: 'A1', fontSize: 20 });
    XLSX.utils.book_append_sheet(workbook, worksheet, 'OrderRequestList');
    XLSX.writeFile(workbook, 'OrderRequestList.xlsx');
  }

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tableData.length) : 0;



  const setOrderDetailNum = async (e, orderNum, vinNum, fanNum, bacNum, urlLink) => {
    e.preventDefault()
    setLoading(orderNum);
    const url = ApiList.getOrderDetail;
    const data = {
      orderData: {
        orderNumber: orderNum,
        partnerType: userDetails.partnerType,
        fan: fanNum,
        vin: vinNum,
        bac: bacNum
      }
    }

    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const response = await axios
    axios.post(url, data, config)
      .then(res => {
        if (res.data.statusMessage === "SUCCESS") {
          log.info(`fos_ui_log: OrderRequestList():setOrderDetailNum Successful data fetch : ${orderNum}`)
          dispatch(setOrderDetailData(res.data.orderDetail));
          dispatch(setOrderSearchType('leftClick'));
          window.location.href = urlLink;
        }
        else {
          setOpenErrorMessage(true)
          setErrorType('error')
          /* setErrorMessage(res.data.statusMessage) */
          log.info(`fos_ui_log: OrderRequestList():setOrderDetailNum ${res.data.statusMessage}`)
        }
      })

      .catch((err) => {
        setOpenErrorMessage(true)
        setErrorType('error')
        /* setErrorMessage(err.message) */
        setErrorMessage(intl.formatMessage({ id: err.message.toString().toUpperCase().replace(/ /g, "_"), defaultMessage: err.message }))
        log.info(`fos_ui_log: OrderRequestList():setOrderDetailNum ${err.message}`)
      });
  }




  const closeErrorMessage = (reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenErrorMessage(false);
  }


  const setOrderDetailField = async (orderNum, vinNum, fanNum, bacNum) => {
    const data = {
      orderData: {
        orderNumber: orderNum,
        partnerType: userDetails.partnerType,
        fan: fanNum,
        vin: vinNum,
        bac: bacNum
      }
    }
    dispatch(setOrderDetailSearch(data));
    dispatch(setOrderSearchType('rightClick'));
  }

  const theme = createTheme({
    //sets color of text in dropdown/selectors 
    palette: {
      primary: {
        main: '#00439D',
      },
      secondary: {
        main: '#11cb5f',
      },
    },
  });





  return (
    <Box sx={styles.masterMargin}>
      <Typography variant="h2" id="tableTitle" component="div"
        sx={styles.h2PageTitle}><>

          <FormattedMessage id="orderRequestList.title" defaultMessage='Order Request List' />
        </></Typography>
      <Paper sx={{ width: '100%', mb: 2 }}>
      {isLoading == false ? (
        <Grid container sx={styles.tablePadding}>
          <EnhancedTableToolbar exportToExcel={exportToExcel} numSelected={selected.length} />
          <TableContainer>
            <Table
              id="orderRequestTable"
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={dense ? 'small' : 'medium'}
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
              />
              <TableBody>

                {stableSort(tableData, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const isItemSelected = isSelected(row.orderNum);
                    return (
                      <TableRow
                        key={index}
                        sx={styles.orderRequestListRow}
                        onClick={(event) => handleClick(event, row.orderNum)}
                        aria-selected="true"
                        tabIndex={-1}
                        selected={isItemSelected}
                      >
                        <ThemeProvider theme={theme}>
                          <TableCell align="left" sx={index % 2 ? styles.orderRequestListStickyCell : styles.orderRequestListStickyCell2} /* onContextMenu={(e) => handleContextMenuForOrderList(e, row)} */>
                            {loading !== row.orderNum ? (
                              <Link sx={styles.orderRequestLinkStyle}
                                onContextMenu={() => setOrderDetailField(row.orderNum, row.vin, row.primaryFAN, row.chargeToBac)}
                                onClick={(e) => setOrderDetailNum(e, row.orderNum, row.vin, row.primaryFAN, row.chargeToBac, "/orderdetail")}
                                href='/orderdetail' underline="none">
                                {row.orderNum}
                              </Link>
                            ) : (<CircularProgress />)}
                          </TableCell>
                        </ThemeProvider>
                        <TableCell align="left" sx={styles.orderRequestListCell}>{row.failedEdits}</TableCell>
                        <TableCell align="left" sx={styles.orderRequestListCell}>

                          {/* {row.currentEvent.split(' - ')[0]} - <FormattedMessage
                            id={`eventcode.${row.currentEvent.split(' ')[0]}`}
                            values={{ eventcodedesc: row.currentEvent.split(' - ')[1] }}
                            defaultMessage={row.currentEvent} /> */}


                          {row.currentEvent} - <FormattedMessage
                            id={`eventcode.${row.currentEvent}`}
                            defaultMessage={row.currentEvent} />



                        </TableCell>
                        <TableCell align="left" sx={styles.orderRequestListCell}>{row.eventDate}</TableCell>
                        <TableCell align="left" sx={styles.orderRequestListCell}>{row.division}</TableCell>
                        <TableCell align="left" sx={styles.orderRequestListCell}>{row.allocationGroup}</TableCell>
                        <TableCell align="left" sx={styles.orderRequestListCell}>{row.model}</TableCell>
                        <TableCell align="left" sx={styles.orderRequestListCell}>{row.modelYear}</TableCell>
                        <TableCell align="left" sx={styles.orderRequestListCell}>{row.numOfVehicles}</TableCell>
                        <TableCell align="left" sx={styles.orderRequestListCell}>{row.shipToBAC}</TableCell>
                        <TableCell align="left" sx={styles.orderRequestListCell}>{row.custPoNbr}</TableCell>
                        <TableCell align="left" sx={styles.orderRequestListCell}>{row.orderReceiptDate}</TableCell>
                        <TableCell align="left" sx={styles.orderRequestListCell}>{row.actualTPW}</TableCell>
                        <TableCell align="left" sx={styles.orderRequestListCell}>{row.balanceToGo}</TableCell>
                        <TableCell align="left" sx={styles.orderRequestListCell}>{row.parentOrderNum}</TableCell>
                        <TableCell align="left" sx={styles.orderRequestListCell}>{row.primaryFAN}</TableCell>
                        <TableCell align="left" sx={styles.orderRequestListCell}>{row.endUserFAN}</TableCell>
                        <TableCell align="left" sx={styles.orderRequestListCell}>{row.orderTypeCd}</TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow

                    style={{
                      height: (dense ? 33 : 53) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            labelRowsPerPage={<FormattedMessage id='labelRowsPerPage' defaultMessage='Row per page: ' />}
            SelectProps={{ MenuProps: { disableScrollLock: true } }}
            rowsPerPageOptions={[5, 10, 50, 100]}
            component="div"
            count={tableData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Grid>
        ):(<CircularProgress />)}
      </Paper>
      <Grid>

        <Modal
          disableScrollLock={true}
          open={open}
          onClose={handleClose}
          aria-labelledby="parent-modal-title"
          aria-describedby="parent-modal-description"
        >
          <Box sx={styles.orderDetailPopUp}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ color: 'white', backgroundColor: '#0072CE', fontSize: '18px' }} align="center" colSpan={3}> Information for BAC: {shipToBac}</TableCell>
                </TableRow>
                <TableRow sx={{ backgroundColor: '#EEEEEE' }}>
                  <TableCell>Name</TableCell>
                  <TableCell>City</TableCell>
                  <TableCell>State/Province</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{companyName}</TableCell>
                  <TableCell>{city}</TableCell>
                  <TableCell>{state}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <br />
            <Stack sx={styles.orderRequestListStackButton}>
              <Button sx={styles.orderRequestListButton} onClick={handleClose}>Close</Button>
            </Stack>
          </Box>
        </Modal>

      </Grid>
      {//openErrorMessage === true &&
        /*<ErrorSnackbarNotification open={openErrorMessage} handleClose={closeErrorMessage} errorMessage={errorMessage} errorType={errorType} />*/
      }
      {errorMessage.length > 0 &&
        <ErrorSnackbarNotification errorType={errorType} open={error} handleClose={handleCloseError} errorMessage={errorMessage} />
      }
      {}
    </Box>
  );
}
